import type { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  actions?: ReactNode;
}

/** Centered empty/placeholder state used across the funnel, trees, search, and library. */
export function EmptyState({ icon, title, description, actions }: EmptyStateProps) {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 1.5,
        p: 4,
        color: 'text.secondary',
      }}
    >
      {icon && <Box sx={{ color: 'text.disabled', '& svg': { fontSize: 44 } }}>{icon}</Box>}
      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary' }}>
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" sx={{ maxWidth: 420 }}>
          {description}
        </Typography>
      )}
      {actions && (
        <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
          {actions}
        </Stack>
      )}
    </Box>
  );
}

export default EmptyState;
